<template>
  <div class="col-md-12" style="height: 100%;" v-if="LeaveHistory.length > 0">
    <div class="row" style="padding-top: 24px; padding-bottom: 15px;">
      <div class="col-md-12">
        <div class="col-md-10">History of the leaves you have applied so far.</div>
        <div class="col-md-1">
          <ob-button class="clear-btn" v-if="isFilterApplied" type="link" @click="clearSearch">Clear</ob-button>
        </div>
        <div v-if="$route.name != 'employee-LeaveReport-trainee'" class="col-md-1">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_filter.svg`" alt="image" @click="showFilter = true" />
        </div>
        <leave-history-filter
          :AuthPerson="AuthPerson"
          :LeaveType="LeaveType"
          @cancel="cancelFilter"
          @apply="getLeaveHistory"
          v-if="showFilter"
        ></leave-history-filter>
      </div>
    </div>

    <div class="row" style="margin-left: 5px;margin-right: 5px;">
      <template class="daterange" v-for="(item,index) in LeaveHistory">
        <ob-collapse :type="11" :expand="false" :disabled="false" theme="default">
         <template slot="collapse-title">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;" />

            <span style="color:#333333;margin-right: 5px;text-transform: capitalize;"  v-if="item.LeaveTypeList.length > 1">{{getLeaveTypeString(item.LeaveTypeList)}}</span>
            <span style="color:#333333;margin-right: 5px;text-transform: capitalize;" v-else>{{item.Type}}</span>
            <span style="color:#8595A6">{{getDateFormat(item.FromDate)}} to {{getDateFormat(item.ToDate)}}</span>
            <span style="display: inline-block;position:absolute;margin-top:15px;left: 60px;font-weight:600;font-size: 11px;">({{getFormatedDayType(item.StartDay)}}-{{getFormatedDayType(item.EndDay)}})</span>
             </template>
           <template slot="collapse-title-right">
            <span :class="{'statusCls': $route.name == 'employee-LeaveReport-trainee'}" style="width: 80px; display:inline-block;position: absolute;right: 35%;">
              <span
                :class="item.Status == 'Approved' ? 'circle' : item.Status == 'Pending' ? 'circle3' : item.Status == 'Revoked' ? 'circle2':'circle1'"
              ></span>
              <span style="font-weight:600">{{item.Status}}</span>
            </span>
             <span v-if="item.TotalDays>1" :class="{'daysCls': $route.name == 'employee-LeaveReport-trainee'}"
              style="margin-right: 10px;width:165px;display: inline-block; "
            >{{item.TotalDays*8}} hours ({{item.TotalDays}} days)</span>
            <span v-else :class="{'daysCls': $route.name == 'employee-LeaveReport-trainee'}"
              style="margin-right: 10px;width:165px;display: inline-block;"
            >{{item.TotalDays*8}} hours ({{item.TotalDays}} day)</span>
            <span style="margin-right: 6px;" v-if="item.Status == 'Approved' && $route.name == 'employee-LeaveReport-trainee'"><ob-button @click="onLeaveRevoke(item)" type="secondary">Revoke</ob-button></span>
            <span style="margin-right: 6px;" v-if="item.Status == 'Pending' && $route.name == 'employee-LeaveReport-trainee'"><ob-button @click="onLeaveReject(item)" type="secondary">Reject</ob-button></span>
            <span style="margin-right: 6px;" v-if="item.Status == 'Pending' && $route.name == 'employee-LeaveReport-trainee'"><ob-button @click="onLeaveApprove(item)">Approve</ob-button></span>
          </template>
          <template slot="collapse-details">
            <div class="form-group row">
              <div class="col-md-12 pL0">
                <div class="col-md-6">
                  <label>Authorized Person</label>
                  <h5
                    style="font-weight:600"
                  >{{item.Status == 'Pending' ? 'N/A' : item.AuthorizedPerson}}</h5>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label>Leave Reason</label>
                <h5 style="font-weight:600">{{item.Reason}}</h5>
              </div>
              <div class="col-md-12" v-if="item.TravellingOutOfCountry == true">
                <h5 style="font-weight:600:font-size:14px;padding-bottom:10px;">
                  <b>Note: Travelling out of country</b>
                </h5>
              </div>
              <div class="col-md-12" style="margin-top:5px;">
                <template v-for="(item,index) in item.Attachments">
                  <div class="attachments-view">
                    <template>
                      <span class="fileName">{{item | I9URL2FileName}}</span>
                      <ob-popover trigger="click" :options="{placement: 'bottom'}">
                      <div class="popper" style="padding:0px">
                          <div style="padding:10px;">
                              <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                              <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                              <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                          </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-10px;margin-left:10px" />
                  </ob-popover>
                    </template>
                  </div>
                </template>
              </div>
            </div>
            <div
              v-if="item.RejectReason != null && item.RejectReason != ''"
              class="row"
              style="border-top: 1.5px dashed #d4cccc;margin-top:10px;"
            >
              <div class="col-md-12" style="margin-top:15px;">
                <label>{{item.Status == 'Rejected' ? 'Reject Reason' : 'Reason for Revocation'}}</label>
                <h5 style="font-weight:600">{{item.RejectReason}}</h5>
              </div>
            </div>
          </template>
        </ob-collapse>
      </template>
    </div>
    <ob-modal2 :show.sync="show">
                <template slot="modal-title">
                    <h4 style="font-weight:600;">
                        Reject Leave
                        <span
                        style="color:#8595A6;font-size:12px;margin-left:14px;"
                        >Start Date:{{getDateFormat(LeaveRecord.FromDate)}} | End Date: {{getDateFormat(LeaveRecord.ToDate)}}</span>
                    </h4>
                </template>
                <template slot="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <label>Reason for Rejection</label><span class="validation-star">*</span>
                            <ob-textarea :maxLength="1000" v-model="LeaveRejectReason" ></ob-textarea>
                        </div>
                    </div>
                </template>
                <template slot="modal-footer">
                    <ob-button type="secondary" @click="cancelPopup()">Cancel</ob-button>
                    <!-- <ob-button @click="onRejectLeave()" :class="{ 'editDisable': (LeaveRejectReason == '' || LeaveRejectReason == null)}">Reject</ob-button> -->
                    <ob-button style="color: #fff;" @click="onRejectLeave()" :class="{ 'editDisable': (LeaveRejectReason == '' || LeaveRejectReason == null)}">Reject</ob-button>
                </template>
            </ob-modal2>
            <ob-modal2 :show.sync="revokeShow">
                <template slot="modal-title">
                    <h4 style="font-weight:600;">
                        Revoke Leave
                    </h4>
                </template>
                <template slot="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <label>Reason for Revoke</label><span class="validation-star">*</span>
                            <ob-textarea :maxLength="1000" v-model="LeaveRevokeReason" ></ob-textarea>
                        </div>
                    </div>
                </template>
                <template slot="modal-footer">
                    <ob-button type="secondary" @click="cancelRevokPopup()">Cancel</ob-button>
                    <!-- <ob-button @click="onRejectLeave()" :class="{ 'editDisable': (LeaveRejectReason == '' || LeaveRejectReason == null)}">Reject</ob-button> -->
                    <ob-button style="color: #fff;" @click="onRevokeLeave()" :class="{ 'editDisable': (LeaveRevokeReason == '' || LeaveRevokeReason == null)}">Revoke</ob-button>
                </template>
            </ob-modal2>
  </div>
  <div class="col-md-12" style="height: 100%;" v-else-if="isFilterApplied">
    <div class="row" style="padding-top: 24px; padding-bottom: 15px;">
      <div class="col-md-12">
        <div class="col-md-10">History of the leaves you have applied so far.</div>
        <div class="col-md-1">
          <ob-button class="clear-btn" @click="clearSearch" type="link">Clear</ob-button>
        </div>
        <div class="col-md-1">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_filter.svg`" alt="image" @click="showFilter = true" />
        </div>
        <leave-history-filter
          :AuthPerson="AuthPerson"
          :LeaveType="LeaveType"
          @cancel="cancelFilter"
          @apply="getLeaveHistory"
          v-if="showFilter"
        ></leave-history-filter>
      </div>
    </div>
    <div class="MT-Content-table">
      <div class="MT-Content">
        <div style="margin-bottom: 20px;">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_noleave.svg`" />
        </div>
        <div style="font-size: 14px;">No results found</div>
      </div>
    </div>
  </div>
  <div class="col-md-12" style="height: 100%;" v-else>
    <div class="MT-Content-table">
      <div class="MT-Content">
        <div style="margin-bottom: 20px;">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_noleave.svg`" />
        </div>
        <div style="font-size: 14px;">You haven’t applied any leaves.</div>
      </div>
    </div>
  </div>
</template>
<script>
import c from "Vue/Core/constants.js";
import LeaveHistoryFilter from "./LeaveHistoryFilter";
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin.js'

export default {
  mixins: [CommonFunctionMixin],
  props: ["content"],
  data() {
    return {
      show:false,
      revokeShow:false,
      LeaveRevokeReason:'',
      LeaveRejectReason:'',
      LeaveRecord:'',
      isFilterApplied: false,
      AuthPerson: [],
      LeaveType: [],
      showFilter: false,
      LeaveHistory: []
    };
  },
  components: {
    "leave-history-filter": LeaveHistoryFilter
  },
  watch:{
    show(val){
            if(val){
                this.resetValues()   
            }
        },
        revokeShow(val){
            if(val){
                this.resetRevokeValues()   
            }
        }
  },
  computed: {
    EmployeeId() {
            if(this.$route.query.EmployeeId){
                return this.$route.query.EmployeeId
            }
            else
                return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
            },
  },
  created() {
    this.getLeaveHistory();
  },

  methods: {
    getFormatedDayType(val){
     if(val=="MidDay"){
       return "Midday"
     }
     else if(val=="StartOfTheDay"){
        return "Start of the day"
     }
     else if(val=="EndOfTheDay"){
       return "End of the day"
     }
    },
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    onLeaveReject(event)
        {
            this.show = true
            this.LeaveRecord =  event  
        },
        onLeaveRevoke(event){
            this.revokeShow = true
            this.LeaveRecord = event
        },
        onLeaveApprove(Event)
        {
            var LeaveObj = {
                Id  : Event.LeaveId,
                Status : "Approved",
                Reason : this.LeaveRejectReason
            }
            this.AcceptOrRejectLeave(LeaveObj)
        },
        onRejectLeave()
        {
            if(this.LeaveRejectReason != '' && this.LeaveRejectReason != null)
            {
                var LeaveObj = {
                    Id  : this.LeaveRecord.LeaveId,
                    Status : "Rejected",
                    Reason : this.LeaveRejectReason
                }
                this.AcceptOrRejectLeave(LeaveObj)
                this.show = false
            }
        },
        onRevokeLeave()
        {
            if(this.LeaveRevokeReason != '' && this.LeaveRevokeReason != null)
            {
                var LeaveObj = {
                    Id  : this.LeaveRecord.LeaveId,
                    Status : "Revoked",
                    Reason : this.LeaveRevokeReason
                }
                this.AcceptOrRejectLeave(LeaveObj)
                this.revokeShow = false
            }
        },
        AcceptOrRejectLeave(LeaveObj){
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`/Leave/ApproveOrReject`,LeaveObj,(res) => {
                if(res.data.State == true){
                    this.$message({
                        type: 'success',
                        message: LeaveObj.Status == "Rejected" ? "Rejected Successfully" : LeaveObj.Status == "Revoked" ? "Revoked Successfully" : "Approved Successfully"
                    });
                   this.getLeaveHistory();
                }else{
                    this.$message({
                        type:'error',
                        message: res.data.Message
                    })
                }
                this.$loading({}).close()
            })
        },
        resetValues() {
            this.LeaveRejectReason = "";
        },
        resetRevokeValues()
        {
             this.LeaveRevokeReason = "";
        },
        cancelPopup(){
            this.show = false
        },
        cancelRevokPopup()
        {
            this.revokeShow = false
        },
    getLeaveTypeString(list) {
      var str = "";
      for (var i = 0; i < list.length; i++) {
        str = str + list[i].LeaveType + "(" + list[i].TotalDays + ")" + ", ";
      }
      var leaveType = str.slice(0, -2);
      return leaveType;
    },
    clearSearch() {
      this.isFilterApplied = false;
      this.getLeaveHistory();
    },
    cancelFilter() {
      this.showFilter = false;
    },
    AuthPersonList() {
      for (var i = 0; i < this.LeaveHistory.length; i++) {
        var x = {
          id: this.LeaveHistory[i].AuthorizedPerson.trim(),
          text: this.LeaveHistory[i].AuthorizedPerson.trim()
        };
        this.AuthPerson[i] = x;
      }
      this.AuthPerson = this.AuthPerson.filter((thing, index) => {
        return (
          index ===
          this.AuthPerson.findIndex(obj => {
            return JSON.stringify(obj) === JSON.stringify(thing);
          })
        );
      });
      console.log("unique auth persons", this.AuthPerson);
    },
    getLeaveType() {
      for (var i = 0; i < this.LeaveHistory.length; i++) {
        var y = {
          id: this.LeaveHistory[i].Type.trim(),
          text: this.LeaveHistory[i].Type.trim()
        };
        this.LeaveType[i] = y;
      }
      this.LeaveType = this.LeaveType.filter((thing, index) => {
        return (
          index ===
          this.LeaveType.findIndex(obj => {
            return JSON.stringify(obj) === JSON.stringify(thing);
          })
        );
      });
      console.log("unique leaves", this.LeaveType);
    },
    getLeaveHistory(obj, clearFilter) {
      this.$loading({ loadingText: "Loading..." });
      // on page load or empty filter
      if (!obj) obj = {};
      if (clearFilter) {
        this.isFilterApplied = true;
      }
      // API call
      ajax.put(`/Leave/${this.EmployeeId}/History`, obj, res => {
        this.LeaveHistory = res.data.LeaveHistory;
        this.AuthPersonList();
        this.getLeaveType();
        this.$loading({}).close();
      });
    },
    getDateFormat(date) {
      var date = moment(date).format("Do MMM YYYY");
      return date;
    },
  }
};
</script>
<style scoped>
.control-label {
  color: #8695a5;
}
.form-control-static {
  color: #475259;
  font-weight: 600;
}
.section-title {
  color: #4d92df;
  font-size: 13px;
  margin: 0 0 15px;
  font-weight: 600;
}
.section {
  color: rgb(103, 106, 108);
  font-size: 13px;
  margin: 0 0 15px;
  font-weight: 600;
}
.label {
  border-radius: 10px;
}
label {
  font-weight: 400;
}
.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #13da7c;
  background-color: #13da7c;
}
.circle1 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #ff5257;
  background-color: #ff5257;
}
.circle2 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #ffda51;
  background-color: #ffda51;
}
.circle3 {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  display: inline-block;
  color: #000000;
  background-color: #000000;
}
.fileName {
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.attachments-view {
  margin-top: 5px;
  /* color: #4a90e2; */
  margin-left: 0px;
  border: 1px solid #4a90e2 !important;
  background: #e6eff9 !important;
  padding: 1px 10px;
  display: inline-block;
  border-radius: 30px;
  font-weight: bold;
  float: left;
  margin-right: 2%;
}
.statusCls{
  position:absolute;
  right:25% !important;
}
.daysCls{
  position: absolute;
  right: 30%;

text-align: left ;
  
}
.editDisable{
    cursor: not-allowed !important;
    color:#fff !important;
}
.cursorCls
{
  cursor:not-allowed !important;
}
.hideShow
{
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/LeaveHistory.vue